// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { InstantSearchResultListView } from "../schema";

export function serialize_InstantSearchResultListView_internal(value: InstantSearchResultListView): unknown {
  return ((value: { activationTime: DateTime<true> | null; authorInfo: string | null; contentItemType: string; id: bigint; thumbnail: string; title: string; url: string }): unknown => {
    return {
      activationTime: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["activationTime"]),
      authorInfo: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["authorInfo"]),
      contentItemType: ((value: string): unknown => {
        return value;
      })(value["contentItemType"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      thumbnail: ((value: string): unknown => {
        return value;
      })(value["thumbnail"]),
      title: ((value: string): unknown => {
        return value;
      })(value["title"]),
      url: ((value: string): unknown => {
        return value;
      })(value["url"]),
    };
  })(value);
}
export function serialize_InstantSearchResultListView(obj: InstantSearchResultListView): string {
  return renderJsonWithNumbersAsBigint(serialize_InstantSearchResultListView_internal(obj));
}
export function deserialize_InstantSearchResultListView_internal(value: unknown): ParserResult<InstantSearchResultListView> {
  return ((
    value: unknown,
  ): ParserResult<{
    activationTime: DateTime<true> | null;
    authorInfo: string | null;
    contentItemType: string;
    id: bigint;
    thumbnail: string;
    title: string;
    url: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "activationTime")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/activationTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activationTime'.` };
    }
    const parsed_activationTime = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/activationTime]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/activationTime]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["activationTime"]);
    })();
    if (!parsed_activationTime.success) {
      return { success: false, reason: parsed_activationTime.reason };
    }
    if (!hasProp(value, "authorInfo")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/authorInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorInfo'.` };
    }
    const parsed_authorInfo = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/authorInfo]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["authorInfo"]);
    })();
    if (!parsed_authorInfo.success) {
      return { success: false, reason: parsed_authorInfo.reason };
    }
    if (!hasProp(value, "contentItemType")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/contentItemType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemType'.` };
    }
    const parsed_contentItemType = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/contentItemType]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["contentItemType"]);
    })();
    if (!parsed_contentItemType.success) {
      return { success: false, reason: parsed_contentItemType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "thumbnail")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/thumbnail]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'thumbnail'.` };
    }
    const parsed_thumbnail = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/thumbnail]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["thumbnail"]);
    })();
    if (!parsed_thumbnail.success) {
      return { success: false, reason: parsed_thumbnail.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    if (!hasProp(value, "url")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/url]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'url'.` };
    }
    const parsed_url = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/InstantSearchResultListView/url]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["url"]);
    })();
    if (!parsed_url.success) {
      return { success: false, reason: parsed_url.reason };
    }
    return {
      success: true,
      value: {
        activationTime: parsed_activationTime.value,
        authorInfo: parsed_authorInfo.value,
        contentItemType: parsed_contentItemType.value,
        id: parsed_id.value,
        thumbnail: parsed_thumbnail.value,
        title: parsed_title.value,
        url: parsed_url.value,
      },
    };
  })(value);
}
export function deserialize_InstantSearchResultListView(str: string): ParserResult<InstantSearchResultListView> {
  return deserialize_InstantSearchResultListView_internal(parseJsonWithNumbersAsBigint(str));
}
